export enum SigningTemplateSlotNames {
    SignerRole = 'Employee',
    PrimaryCosigner = 'Primary Cosigner',
    SecondaryCosigner = 'Secondary Cosigner',
    TertiaryCosigner = 'Tertiary Cosigner',
    Candidate = 'Candidate',
}
